import React from "react";

type MesEmptyStateProps = {
  icon: string; // font-awesome icon class without leading "fa "
  title: string;
  subtitle?: string;
};

const MesEmptyState: React.FC<MesEmptyStateProps> = ({ icon, title, subtitle }) => {
  return (
    <div className="tv-empty-state">
      <div className="tv-empty-state-icon">
        <i className={`fa ${icon}`} aria-hidden="true" />
      </div>
      <h5>{title}</h5>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
  );
};

export default MesEmptyState;

